export default {
    SET_LOGS(state, logs) {
        state.logs = logs;
    }
}
